import { render, staticRenderFns } from "./DiscountCheck.vue?vue&type=template&id=f20de0d4&"
import script from "./DiscountCheck.vue?vue&type=script&lang=js&"
export * from "./DiscountCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports